export default [
  // {
  //   path: '/',
  //   name: 'home',
  //   component: () => import('../views/stub/stub'),
  //   // redirect: () => {
  //   //   window.location = 'https://mozgo.com';
  //   // },
  //   meta: {
  //     layout: ' homepage',
  //     title: 'Mozgo',
  //   },
  // },
  {
    path: '/',
    name: 'home',
    props: true,
    component: () => import('../views/Home.vue'),
    // redirect: () => {
    //   window.location = 'https://mozgo.com';
    // },
    meta: {
      layout: 'homepage',
      title: 'Главная',
    },
  },
  {
    path: '/password/reset/:auth',
    name: 'home',
    component: () => import('../views/Home.vue'),
    // redirect: () => {
    //   window.location = 'https://mozgo.com';
    // },
    meta: {
      layout: 'homepage',
      title: 'Главная',
    },
  },
  {
    path: '/mail-auth/:mail_auth',
    name: 'home',
    component: () => import('../views/Home.vue'),
    // redirect: () => {
    //   window.location = 'https://mozgo.com';
    // },
    meta: {
      layout: 'homepage',
      title: 'Главная',
    },
  },
  {
    path: '/resend/:code',
    name: 'home',
    component: () => import('../views/Home.vue'),
    // redirect: () => {
    //   window.location = 'https://mozgo.com';
    // },
    meta: {
      layout: 'homepage',
      title: 'Главная',
    },
  },
  {
    path: '/:provider/callback',
    name: 'home',
    component: () => import('../views/Home.vue'),
    // redirect: () => {
    //   window.location = 'https://mozgo.com';
    // },
    meta: {
      layout: 'homepage',
      title: 'Главная',
    },
  },
  {
    path: '/timetable',
    name: 'timetable',
    component: () => import('../views/home-page-layouts/Timetable.vue'),
    meta: {
      layout: 'homepage',
      title: 'Расписание',
    },
  },
  {
    path: '/applicationsExport',
    name: 'applicationsExport',
    props: true,
    component: () => import('../views/partners/applicationsExport/index.vue'),
    meta: {
      layout: 'homepage',
      title: 'Расписание',
    },
  },
  {
    path: '/timetable/:provider/callback',
    name: 'timetable',
    component: () => import('../views/home-page-layouts/Timetable.vue'),
    meta: {
      layout: 'homepage',
      title: 'Расписание',
    },
  },
  {
    path: '/invite/:team_id',
    name: 'home',
    component: () => import('../views/Home.vue'),
    meta: {
      layout: 'homepage',
      title: 'Приглашение',
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    redirect: () => {
      window.location = 'https://mozgo.com';
    },
  },
  {
    path: '/results/general',
    name: 'results-general',
    component: () => import('../views/home-page-layouts/Results-General.vue'),
    meta: {
      layout: 'homepage',
      title: 'Результаты',
    },
  },
  {
    path: '/results/tuts',
    name: 'results-tuts',
    component: () => import('../views/home-page-layouts/Results-Tuts.vue'),
    meta: {
      layout: 'homepage',
      title: 'Результаты',
    },
  },
  {
    path: '/promos/:packId',
    name: 'promocodes._pack_id',
    component:
        () => ({
          // The component to load (should be a Promise)
          component: import(/* webpackChunkName: "partners" */ '../views/promocodes/_pack_id.vue'),
          // A component to use while the async component is loading
          // loading: LoadingComponent,
          // A component to use if the load fails
          // error: ErrorComponent,
          // Delay before showing the loading component. Default: 200ms.
          delay: 200,
          // The error component will be displayed if a timeout is
          // provided and exceeded. Default: Infinity.
          timeout: 3000,
        }),
    meta: {
      layout: 'promocodes',
      title: 'Promocodes',
    },
  },
  {
    path: '/votes/:id',
    name: 'votes',
    component: () => import('../views/game-votes/game-votes.vue'),
    meta: {
      layout: 'votes',
      title: 'Голосование',
    },
  },
];
